import { Inbox, TicketIntegration } from 'shared/src/typings/bootstrap'

import { RootState } from 'typesafe-actions'

import { getGates } from '../gates/selectors'

const root = (state: RootState) => state.convo.org

export const getLimitNumChatsEnabled = (state: RootState): boolean =>
  !!root(state).orgProperties.limitNumChatsEnabled

export const getLimitNumChats = (state: RootState): number | undefined =>
  root(state).orgProperties.limitNumChats

export const getOrgActivated = (state: RootState): boolean =>
  !!root(state).orgProperties.orgActivated

export const getInboxes = (state: RootState): Inbox[] => root(state).inboxes

export const getShowUnfurls = (state: RootState): boolean => !!root(state).orgSettings.showUnfurls

export const getOutboundInboxId = (state: RootState): number | undefined =>
  root(state).orgProperties.outboundInboxId

export const getOrgHasAISuggestedRepliesEnabled = (state: RootState): boolean | undefined =>
  root(state).orgProperties.AISuggestedRepliesEnabled

const getTicketIntegration = (state: RootState): TicketIntegration | undefined =>
  root(state).orgSettings.ticketIntegration

export const getUsesSalesforceTicketing = (state: RootState): boolean =>
  getTicketIntegration(state) === 'SALESFORCE'

export const hasSalesforceCases = (state: RootState): boolean =>
  !!getGates(state).has_salesforce_cases
